export default __webpack_public_path__ + "static/media/eg.49251726.svg";